import React from "react";
import AccordionSummary from "@mui/material/AccordionSummary";
import { ExpandMore } from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import AccordionDetails from "@mui/material/AccordionDetails";
import Accordion from "@mui/material/Accordion";
import { SxProps, Theme } from "@mui/system";
import { Box, Divider } from "@mui/material";
import Image from "next/image";
import { ProductInfoSection } from "src/models/newProduct/getNewProduct";
import { colors } from "src/config/colors";

interface AnotherLinksListProps {
  title?: string;
  sx?: SxProps<Theme>;
  data: ProductInfoSection;
  image: string;
}

const ProductBottomInfo: React.FC<AnotherLinksListProps> = ({
  sx,
  title,
  data,
  image,
}) => (
  <Accordion sx={sx}>
    <AccordionSummary expandIcon={<ExpandMore />}>
      <Image src={image} alt="иконка" width="25px" height="25px" />
      <Typography
        component="h3"
        fontWeight={500}
        color="primary"
        sx={{ ml: 1 }}
      >
        {title}
      </Typography>
    </AccordionSummary>
    <AccordionDetails sx={{ display: "flex", flexWrap: "wrap" }}>
      <Box sx={{ width: "100%" }}>
        <Box
          sx={{ paddingY: "4px", width: "100%" }}
          display="flex"
          justifyContent="space-between"
        >
          <Typography
            sx={{
              fontSize: "14px",
              color: colors.darkGray,
            }}
          >
            Производитель:
          </Typography>
          <Typography
            sx={{
              fontSize: "14px",
              textAlign: "right",
              color: colors.darkBlue,
              fontWeight: 700,
            }}
          >
            {data.company}
          </Typography>
        </Box>
        <Divider light />
        <Box
          sx={{ paddingY: "4px" }}
          display="flex"
          justifyContent="space-between"
        >
          <Typography
            sx={{
              fontSize: "14px",
              color: colors.darkGray,
            }}
          >
            Форма выпуска:
          </Typography>
          <Typography
            sx={{
              fontSize: "14px",
              textAlign: "right",
              color: colors.darkBlue,
              fontWeight: 700,
            }}
          >
            {data?.form}
          </Typography>
        </Box>
        <Divider light />
        <Box
          sx={{ paddingY: "4px" }}
          display="flex"
          justifyContent="space-between"
        >
          <Typography
            sx={{
              fontSize: "14px",
              color: colors.darkGray,
            }}
          >
            Дозировка
          </Typography>
          <Typography
            sx={{
              fontSize: "14px",
              textAlign: "right",
              color: colors.darkBlue,
              fontWeight: 700,
            }}
          >
            {data?.dosage}
          </Typography>
        </Box>
        <Divider light />
        <Box
          sx={{ paddingY: "4px" }}
          display="flex"
          justifyContent="space-between"
        >
          <Typography
            sx={{
              fontSize: "14px",
              color: colors.darkGray,
            }}
          >
            Цена
          </Typography>
          <Typography
            sx={{
              fontSize: "14px",
              textAlign: "right",
              color: colors.darkBlue,
              fontWeight: 700,
            }}
          >
            {!data.min_price
              ? "Нет в наличии"
              : data?.min_price === data?.max_price
              ? `от ${data?.min_price} ₽`
              : `от ${data?.min_price} ₽ до ${data?.max_price} ₽`}
          </Typography>
        </Box>
        <Divider light />
        <Box
          sx={{ paddingY: "4px" }}
          display="flex"
          justifyContent="space-between"
        >
          <Typography
            sx={{
              fontSize: "14px",
              color: colors.darkGray,
            }}
          >
            Количество в упаковке:
          </Typography>
          <Typography
            sx={{
              fontSize: "14px",
              textAlign: "right",
              color: colors.darkBlue,
              fontWeight: 700,
            }}
          >
            {data?.packaging}
          </Typography>
        </Box>
        <Divider light />
        <Box
          sx={{ paddingY: "4px" }}
          display="flex"
          justifyContent="space-between"
        >
          <Typography
            sx={{
              fontSize: "14px",
              color: colors.darkGray,
            }}
          >
            Действующее вещество:
          </Typography>
          <Typography
            sx={{
              fontSize: "14px",
              textAlign: "right",
              color: colors.darkBlue,
              fontWeight: 700,
            }}
          >
            {data?.mnn}
          </Typography>
        </Box>
        <Divider light />
        <Box
          sx={{ paddingY: "4px" }}
          display="flex"
          justifyContent="space-between"
        ></Box>
      </Box>
    </AccordionDetails>
  </Accordion>
);

export default ProductBottomInfo;
